import React from 'react';

import { Button, Checkbox, Divider, Form, Icon, Input, Modal, Radio, Segment } from 'semantic-ui-react'

import './index.css';

import {
    readSetting, saveSetting, openDB
} from '../node_modules/shizzle-core/dist/es/shizzle-core.js'

import {  satsFromMilliPennies, calcPenniesFromSats, calcFromMilliPennies } from './commonReact';


class OtherSettingsModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleModalOk                    = this.handleModalOk.bind(this);


//        this.adjustGuestPostPrice             = this.adjustGuestPostPrice.bind(this)
//        this.adjustFeeThreshold               = this.adjustFeeThreshold.bind(this)
        this.adjustMaxConsecGPsModal          = this.adjustMaxConsecGPsModal.bind(this);
        this.adjustMaxDepthModal              = this.adjustMaxDepthModal.bind(this);

//        this.closeGuestPostPriceAdjustorModal = this.closeGuestPostPriceAdjustorModal.bind(this);
//        this.closeFeeThresholdModal           = this.closeFeeThresholdModal.bind(this);
        this.closeMaxConsecGPsModal           = this.closeMaxConsecGPsModal.bind(this);
        this.closeMaxDepthModal               = this.closeMaxDepthModal.bind(this);

//        this.setNewFeeThreshold               = this.setNewFeeThreshold.bind(this);
//        this.setNewGPPrice                    = this.setNewGPPrice.bind(this);
        this.setNewMaxConsecGPs               = this.setNewMaxConsecGPs.bind(this);
        this.setNewMaxDepthValue              = this.setNewMaxDepthValue.bind(this);


//        this.handleFeeLimitChange             = this.handleFeeLimitChange.bind(this);
            //handleGPPriceChange
        this.handleConsecGPsChange              = this.handleConsecGPsChange.bind(this);
        this.handleMaxDepthChange               = this.handleMaxDepthChange.bind(this);
//        this.handlePermissionChange           = this.handlePermissionChange.bind(this);




        this.BitSchnitzelLLC     = <>BitSchnitzel LLC</>;
        this.shizzleVerse        = <><b>ShizzleVerse</b><small>&trade;</small></>;
        this.bitShizzle          = <><b>BitShizzle</b><small>&trade;</small></>;
        this.bitShizzleItalic    = <><b>Bit<i>Shizzle</i></b><small>&trade;</small></>;
        this.shizzleVerseNotBold = <>ShizzleVerse<small>&trade;</small></>;
        this.bitShizzleNotBold   = <>BitShizzle<small>&trade;</small></>;

        //FIXME: the purples are currently duplicated in index.css
        this.bshzPurple             = '#8313e2';
        this.bshzYellow             = "#fff300";
        this.bshzLtPurp             = '#e7d0fb';
        this.bshzLightYellow        = "#fffccc";

//        this.GUEST_POSTS_PROHIBITED = 4294967295  // aka 4-byte max-int

        const penniesPerSat = this.props.bsvPriceUSD / 1000000
        console.log("US PENNIES per sat: " + penniesPerSat)
        console.log("sats per US Penny: " + 1000000 / this.props.bsvPriceUSD)

        // remember: ctor comes before componentDidMount()
        this.state = {
//            showFeeThresholdAdjustmentModal: false,
//            showGuestPostPriceAdjustmentModal: false,
            showMaxConsecGPsAdjustmentModal: false,
            showMaxDepthAdjustmentModal: false,

            allowGuestPosts: false,
            guestPostPriceForThisIdentity: this.GUEST_POSTS_PROHIBITED,
            gpPrice: this.GUEST_POSTS_PROHIBITED,   // the TEMPORARY value while user is considering adjusting the setting

            //these and their parents are setup in componentDidMount()
            //maxConsec: 0,
            //maxDepth: 10,

            maxMilliPenniesToComment: 0,
            tempMaxToComment: 0,                    // the TEMPORARY value while user is considering adjusting the setting

//            invalidLimit: false,
//            invalidPrice: false,
            invalidValue: false,
        }
    }

    async componentDidMount() {

        console.warn("OtherSettingsModal componentDidMount()")

        let maxConsecGuestPostsForThisIdentity
        let maxDepthForThisIdentity
//        let guestPostPriceForThisIdentity
//        let maxMilliPenniesToComment

        const mcgpfti= await readSetting(await openDB(), "maxConsecGPsFor_" + this.props.siteName + "_" + this.props.siteOwnerCount)
        const mdfti= await readSetting(await openDB(), "maxDepthFor_" + this.props.siteName + "_" + this.props.siteOwnerCount)
//        const gpp = await readSetting(await openDB(), "gpPriceFor_" + this.props.siteName)
//        const mmptc = await readSetting(await openDB(), "maxMilliPenniesToComment")

        let somethingUninitialized = false
        if ( mcgpfti === null || mdfti === null ) {
            somethingUninitialized = true
        }

        // we're *migrating* to use a more-concise gpPriceFor_{site}_{siteOwnerCount}
        if ( mcgpfti === null ) {
                console.warn("You haven't declared how much others must pay to comment on YOUR site."
                    + "\n\nWe'll set it to 25 for now.")

                maxConsecGuestPostsForThisIdentity = 25;

        } else {
            maxConsecGuestPostsForThisIdentity = mcgpfti.value
        }
        if ( mdfti === null ) {
                console.warn("You haven't declared how deep posts can be on YOUR site. We'll set it to 6 for now")

                maxDepthForThisIdentity = 6;

        } else {
            maxDepthForThisIdentity = mdfti.value
        }


        const allowGuestPosts = maxConsecGuestPostsForThisIdentity !== 0
        this.setState({
                        somethingUninitialized:   somethingUninitialized,

//                        maxMilliPenniesToComment: maxMilliPenniesToComment,
//                        tempMaxToComment:         maxMilliPenniesToComment,

                        maxConsecGuestPostsForThisIdentity: maxConsecGuestPostsForThisIdentity,
                            maxConsec:                      maxConsecGuestPostsForThisIdentity,
                        maxDepthForThisIdentity:            maxDepthForThisIdentity,
                            maxDepth:                       maxDepthForThisIdentity,
                        allowGuestPosts: allowGuestPosts,
                    })
    }

    // needed because we may call handleNoClaim() from componentWillMount(), above
    componentWillUnmount() {
        console.log("OtherSettingsModal about to unmount. ")

        // fix Warning: Can't perform a React state update on an unmounted component
        // see: https://stackoverflow.com/questions/53949393/cant-perform-a-react-state-update-on-an-unmounted-component
        this.setState = (state,callback)=>{
            return;
        };
    }

    async handleModalOk() {
        const db = await openDB()

        await saveSetting(db, "maxConsecGPsFor_" + this.props.siteName + "_" + this.props.siteOwnerCount, this.state.maxConsecGuestPostsForThisIdentity)
        await saveSetting(db, "maxConsecDepthFor_" + this.props.siteName + "_" + this.props.siteOwnerCount, this.state.maxDepthForThisIdentity)
        //await saveSetting(db, "maxMilliPenniesToComment", this.state.maxMilliPenniesToComment)

        this.props.closeMe()
    }
/*
    adjustFeeThreshold() {
        console.log("adjustFeeThreshold()")
        this.setState({showFeeThresholdAdjustmentModal: true})
    }
    closeFeeThresholdModal() {
        this.setState({showFeeThresholdAdjustmentModal: false})
    }
*/
    adjustMaxConsecGPsModal() {
        console.log("adjustMaxConsecGPsModal()")
        this.setState({showMaxConsecGPsAdjustmentModal: true})
    }
    closeMaxConsecGPsModal() {
        this.setState({showMaxConsecGPsAdjustmentModal: false,
                        maxConsec: this.state.maxConsecGuestPostsForThisIdentity,
                        invalidValue: false
        })
    }
    adjustMaxDepthModal() {
        console.log("adjustMaxDepthModal()")
        this.setState({showMaxDepthAdjustmentModal: true})
    }
    closeMaxDepthModal() {
        this.setState({showMaxDepthAdjustmentModal: false,
                        maxDepth: this.state.maxDepthForThisIdentity,
                        invalidValue: false
        })
    }
/*
    handleFeeLimitChange(event) {
        const re = /^[0-9\b]+$/;
        console.log("fee limit input: " + event.target.value)
        if (event.target.value === '' || re.test(event.target.value)) {
          if ( event.target.value.length < 11 && Number(event.target.value) < 4294967295) {
            const lenLessThan1 = event.target.value.length < 1
            this.setState({tempMaxToComment: event.target.value,
                invalidLimit: lenLessThan1,
            })
          }
        }
    }
    setNewFeeThreshold() {
        console.log("setNewFeeThreshold()")
        this.setState({ maxMilliPenniesToComment: this.state.tempMaxToComment,
                        somethingUninitialized: false
                })
        this.closeFeeThresholdModal()
    }
*/

/*
    adjustGuestPostPrice() {
        console.log("adjustGuestPostPrice")
        let gpPrice
        if ( !this.state.allowGuestPosts ) {
            gpPrice = this.GUEST_POSTS_PROHIBITED
        } else {
            gpPrice = this.state.guestPostPriceForThisIdentity
        }
        this.setState({showGuestPostPriceAdjustmentModal: true,
                    gpPrice: gpPrice})
    }
    closeGuestPostPriceAdjustorModal() {
        this.setState({showGuestPostPriceAdjustmentModal: false})
    }
*/
    //handleGPPriceChange
    handleConsecGPsChange(event) {
        const re = /^[0-9\b]+$/;
        console.log("input: " + event.target.value)
        if (event.target.value === '' || re.test(event.target.value)) {
          if ( event.target.value.length < 9 && Number(event.target.value) < 16777216) {
            const lenLessThan1 = event.target.value.length < 1
                         //gpPrice
            this.setState({maxConsec /*consecGPsValue*/: event.target.value,
                invalidValue: lenLessThan1,
            })
          }
        }
    }
    setNewMaxConsecGPs() {
        console.log("setNewMaxConsecGPs()")

        //NB: we NEED the state change to RIPPLE before we close.
        //    This allows closeMaxConsecGPsModal() to update the intermediate value to match the new val
        //    So, when the user NEXT opens the adjustor modal, the immediate value is the CURRENT value
        this.setState({ maxConsecGuestPostsForThisIdentity: this.state.maxConsec,
                        somethingUninitialized: false
                    },
                    this.closeMaxConsecGPsModal)
    }

    setNewMaxDepthValue() {
        console.log("setNewMaxDepthValue()")

        //NB: we NEED the state change to RIPPLE before we close.
        //    This allows closeMaxConsecGPsModal() to update the intermediate value to match the new val
        //    So, when the user NEXT opens the adjustor modal, the immediate value is the CURRENT value
        this.setState({ maxDepthForThisIdentity: this.state.maxDepth,
                        somethingUninitialized: false
                    },
                    this.closeMaxConsecGPsModal)
    }
    handleMaxDepthChange(event) {
        const re = /^[0-9\b]+$/;
        console.log("input: " + event.target.value)
        if (event.target.value === '' || re.test(event.target.value)) {
          if ( event.target.value.length < 3 && Number(event.target.value) < 11) {
            const lenLessThan1 = event.target.value.length < 1
                         //gpPrice
            this.setState({maxDepth: event.target.value,
                invalidValue: lenLessThan1 || event.target.value < 5,
            })
          }
        }
    }
/*
    setNewGPPrice() {
        console.log("setNewGPPrice()")

        if ( this.state.allowGuestPosts ) {
            this.setState({ guestPostPriceForThisIdentity: this.state.gpPrice,
                            somethingUninitialized: false
                        })
        } else {
            this.setState({ guestPostPriceForThisIdentity: this.GUEST_POSTS_PROHIBITED,
                            somethingUninitialized: false
                        })
        }
        this.closeGuestPostPriceAdjustorModal()
    }
*/

    /**
     * When checking/un-checking the 'allow guest-posts' box - in the adjustor
     */
/*
    handlePermissionChange (event, data) {
        const field = data.field;
        const value = data.value;
        const checked = data.checked;

        console.log("handlePermissionChange(): allow guest posts: " + checked)

        const newPrice = checked ? 1000 : this.GUEST_POSTS_PROHIBITED

        this.setState({ allowGuestPosts: checked,
                        gpPrice: newPrice
        });

    }
*/

    render() {
        console.warn("OtherSettingsModal  render()")

        // ***  DEVICE-DEPENDENT STYLING  ***
        // For mobile, "detect" landscape screen mode
        const landscape = this.props.isMobile ? window.innerWidth > window.innerHeight : false
        // For mobile, shrink the About, Security, and Glossary modals
        const modalClassName   = this.props.isMobile ?
                                        (landscape ?
                                                "modalMobileLandscape"
                                            :
                                                "modalMobilePortrait"
                                        )
                                    :
                                        ""
        const modalContentClassName = this.props.isMobile ? "modalContentMobile" : ""
        const modalBottomClassName  = this.props.isMobile ? "modalBottomMobile"  : ""



        const maxConsecMention = this.state.maxConsecGuestPostsForThisIdentity === 0 ?
                        <>
                            guests are <span style={{color: "red", fontSize: "1.4rem",}}>prohibited</span> from posting ANY posts
                        </>
                    :
                        <>
                            <span style={{color: "blue", fontSize: "1.4rem",}}>{this.state.maxConsecGuestPostsForThisIdentity}</span> posts
                        </>
        const maxDepthMention = 
                        <>

                        <span style={{color: "blue", fontSize: "1.4rem",}}>{this.state.maxDepthForThisIdentity}</span> levels
                        </>

        const introWords = this.state.somethingUninitialized ?
                            <>
                                Before you start posting on your site, it's worthwhile to understand and review these two
                            </>
                        :
                            <>
                                It may be worthwhile to review these two
                            </>
        const firstTimeMention = this.props.firstTime ?
                <>
                    <div style={{fontSize:"1.6rem", color:"blue"}}>
                        <b style={{color:"red"}}>Right now</b> is an important time to review your Settings
                    </div>
                    Partly because one of the settings cannot be changed for 'a while', after
                    your second post on a site, it's best to review the settings <b>before</b> your
                    second post on a site - particularly the <span style={{color:"blue"}}>"max-consecutive-guest-posts"</span> setting.
                    <Divider />
                </>
            :
                <></>
        const invalidDepthMention = this.state.invalidValue ?
                    <>
                        Note that valid values are from 5 to 10
                    </>
                :
                    <>
                    </>
        const invalidMaxConsecMention = this.state.invalidValue ?
                    <>
                        Note that the minimum value is 0 - which means <b>no</b> guests could post
                    </>
                :
                    <>
                    </>
        return(
                <>
                    <Modal size='small' centered className={modalClassName}  open={true} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> Important Settings for {this.props.siteName.toUpperCase()} </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>
                            {firstTimeMention}
                            <div>
                                {introWords} <b style={{color:"blue"}}>Important Settings</b>.
                                <br></br>
                                <div style={{padding: "10px"}}>
                                    <Segment style={{backgroundColor: "#f8f0f8"}}>
                                    What is the maximum number of <b>consecutive</b> guest-posts you'll allow
                                    on <b>your</b> domain, <span style={{color:"blue"}}><b>{this.props.siteName.toUpperCase()}</b></span>? Limiting
                                    the number can avoid getting overwhelmed by too many guest-posts - like getting too many voicemails.
                                    <div style={{padding: "10px"}}>
                                        <b style={{fontSize: "1.4rem"}}>Maximum Consecutive Guest-Posts: &nbsp;</b>{maxConsecMention}
                                        <br></br>
                                        <button onClick={this.adjustMaxConsecGPsModal} style={{backgroundColor: this.bshzLtPurp}}>Adjust this setting </button>
                                        <br></br>
                                        (NOTE: changes to this setting may take a while to take effect, OR, would require an additional action)
                                    </div>
                                    </Segment>
                                </div>

                                <div style={{padding: "10px"}}>
                                    <Segment style={{backgroundColor: "#f8f0f8"}}>
                                    How deeply should your network of posts on <span style={{color:"blue"}}><b>{this.props.siteName.toUpperCase()}</b></span> extend? The deeper it extends, the more posts you can 
                                    make. However, for someone who doesn't anticipate a zillion posts, there's benefit in <b>not</b> going
                                    too deep: finding posts is quicker with more-shallow trees.
                                    <div style={{padding: "10px"}}>
                                        <b style={{fontSize: "1.4rem"}}>The number of levels you'd prefer: &nbsp;</b><span style={{color: "blue", fontSize: "1.4rem",}}> {maxDepthMention}</span>
                                        <br></br>
                                        <br></br>
                                        <button onClick={this.adjustMaxDepthModal} style={{backgroundColor: this.bshzLtPurp}}>Adjust this setting </button>
                                        <br></br>
                                        (NOTE: changes to this setting may take a while to take effect, OR, would require an additional action)
                                    </div>
                                    </Segment>
                                </div>

                            </div>

                        </Modal.Content>
                        <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
                            <div style={{textAlign: 'center'}}>
                                <Button positive onClick={this.handleModalOk} content='OK'/>
                            </div>
                        </Modal.Actions>
                    </Modal>


                    <Modal size='small' centered className={modalClassName}  open={this.state.showMaxConsecGPsAdjustmentModal} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> Adjust the Maximum CONSECUTIVE guest-posts </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>

                            Let's adjust the <b>Max-Consecutive Guest-Posts</b> - the most you're willing to allow on your site...
                            <br></br>
                            The CURRENT setting is {this.state.maxConsecGuestPostsForThisIdentity}. NOTE: this doesn't mean that this setting has been DEPLOYED. It's the value you last set it to.
                            <br></br>
                            <br></br>
                                Once this limit is reached, visitors won't be able to guest-post here until <b>you</b> post something. This can help
                                you avoid getting overwhelmed, but, an even <b>better</b> approach might be to incrementally raise the guest-post price
                                higher - the more consecutive guest-posts there are (though, this feature is still in-the-works).
                            <br></br>
                            <br></br>
                            To actual make a CHANGE to your domain, you'll need to take an ADDITIONAL step (to be described later).
                            <br></br>
                            <br></br>
                            <div style={{color: "blue"}}> &nbsp; &nbsp; How many <b>consecutive</b> guest-posts would you like to allow on your domain?
                                <br></br>
                                &nbsp; &nbsp; <Input type="text" value={this.state.maxConsec}
                                                    //handleFeeLimitChange
                                        onChange={this.handleConsecGPsChange}
                                        style={{width:"125px"}}/> Max consecutive guest-posts: &nbsp; &nbsp;{this.state.maxConsec}
                            </div>
                            {invalidMaxConsecMention}

                            <br></br>
                            <br></br>
                            <Button positive disabled={this.state.invalidValue} onClick={this.setNewMaxConsecGPs} content='Use this limit'/>

                        </Modal.Content>
                        <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
                            <div style={{textAlign: 'center'}}>
                                <Button negative onClick={this.closeMaxConsecGPsModal} content='Back'/>
                            </div>
                        </Modal.Actions>
                    </Modal>


                    <Modal size='small' centered className={modalClassName}  open={this.state.showMaxDepthAdjustmentModal} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> Adjust Your MaxDepth </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>

                            Let's adjust the maximum posting depth you'd like on your site/domain/identity: <span style={{color:"blue", fontSize:"1.3rem"}}>{this.props.siteName.toUpperCase()}</span>
                            <br></br>
                            The CURRENT setting is {this.state.maxDepthForThisIdentity}. NOTE: this doesn't mean that this setting has been DEPLOYED. It's the value you last set it to.
                            <br></br>
                            <br></br>
                            To actual make a CHANGE to your posting tree, you'll need to take an additional step (to be described later). Though, it's doubtful this needs to be done immediately.
                            <br></br>
                            <br></br>
                            <div style={{color: 'blue'}}> &nbsp; How deep would you like posting on your domain?
                                <br></br>
                                &nbsp; &nbsp; <Input type="text" value={this.state.maxDepth}
                                        onChange={this.handleMaxDepthChange}
                                        style={{width:"125px"}}/> <span> Max depth: &nbsp; &nbsp;{this.state.maxDepth}</span>
                            </div>
                            {invalidDepthMention}
                            <br></br>
                            <br></br>
                                                                                           
                            <Button positive disabled={this.state.invalidValue} onClick={this.setNewMaxDepthValue} content='Use this setting'/>

                        </Modal.Content>
                        <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
                            <div style={{textAlign: 'center'}}>
                                <Button negative onClick={this.closeMaxDepthModal} content='Back'/>
                            </div>
                        </Modal.Actions>
                    </Modal>
                </>
        )
    }
}

export default OtherSettingsModal;
